import { Blocks, Code2, Compass } from "lucide-react";

// Single source of truth for the three coding modes (tracks) on the frontend.
export const MODES = ["junior", "blocks", "python"];
export const BLOCK_MODES = ["blocks", "junior"];

export const MODE_META = {
  junior: {
    id: "junior",
    label: "Junior Blocks",
    short: "Junior",
    icon: Compass,
    art: "/nav/mural_left.webp", // mode picker card background (left side of the Junior mural); hides the icon
    artPos: "38% 100%",
    tagline: "Drive a tank drill through a treasure grid with just a few blocks - perfect for first-time coders.",
    points: ["Snap together move, turn and repeat blocks", "Press Play and watch the drill go", "Reach the treasure to earn points", "Your own Junior Blocks leaderboard"],
    text: "text-amber-600 dark:text-amber-400",
    solid: "bg-amber-500",
    badge: "border-amber-400/60 bg-amber-500/10 text-amber-700 dark:text-amber-300",
    accent: "border-amber-400/50 hover:border-amber-500 hover:bg-amber-500/5",
    pill: "bg-amber-500 text-white",
    border: "border-amber-400",
  },
  blocks: {
    id: "blocks",
    label: "Blocks",
    short: "Blocks",
    icon: Blocks,
    art: "/img/blocks_card.webp", // tablet photo of the Blocks editor; hides the icon on the mode picker card
    artPos: "30% 100%",
    tagline: "Drag and drop blocks to build real programs - great for beginners and younger students.",
    points: ["Snap blocks together, no typing", "See the matching Python as you build", "Same daily drills, streaks and blitz bonuses", "Your own Blocks leaderboard"],
    text: "text-sky-600 dark:text-sky-400",
    solid: "bg-sky-500",
    badge: "border-sky-400/60 bg-sky-500/10 text-sky-600 dark:text-sky-300",
    accent: "border-sky-400/50 hover:border-sky-500 hover:bg-sky-500/5",
    pill: "bg-sky-500 text-white",
    border: "border-sky-400",
  },
  python: {
    id: "python",
    label: "Python",
    short: "Python",
    icon: Code2,
    art: "/img/python_card.webp", // photo of hands typing Python on a laptop; hides the icon on the mode picker card
    artPos: "42% 100%",
    tagline: "Type real Python code in the editor.",
    points: ["Short, fun daily drills", "Streaks, blitz bonuses and challenges", "Reveal answers and hints when you're stuck", "Compete on the Python leaderboard"],
    text: "text-emerald-600 dark:text-emerald-400",
    solid: "bg-emerald-500",
    badge: "border-emerald-400/60 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
    accent: "border-emerald-400/50 hover:border-emerald-500 hover:bg-emerald-500/5",
    pill: "bg-emerald-500 text-white",
    border: "border-emerald-400",
  },
};

export const normalizeMode = (m) => (MODES.includes(m) ? m : "python");
export const isBlockMode = (m) => BLOCK_MODES.includes(m);
export const isJuniorMode = (m) => m === "junior";
export const modeLabel = (m) => MODE_META[normalizeMode(m)].label;

// Admin-editable copy on the mode cards (title, short name, tagline, bullet points)
export const MODE_TEXT_FIELDS = ["label", "short", "tagline", "points"];
export const MODE_TEXT_DEFAULTS = Object.fromEntries(
  MODES.map((m) => [m, { label: MODE_META[m].label, short: MODE_META[m].short, tagline: MODE_META[m].tagline, points: [...MODE_META[m].points] }])
);

// Apply saved overrides in place so every component reading MODE_META shows the edited names
export const applyModeContent = (overrides = {}) => {
  MODES.forEach((m) => {
    const o = overrides[m] || {};
    MODE_TEXT_FIELDS.forEach((f) => {
      const v = o[f];
      MODE_META[m][f] = f === "points" ? (Array.isArray(v) && v.length ? v : MODE_TEXT_DEFAULTS[m].points) : (v || MODE_TEXT_DEFAULTS[m][f]);
    });
  });
};
